import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { AppConsts } from '@application/common/constants/app-consts';
import { getAllSmallJobWorkOrderAsync, getAllTechniciansWithWorkordersAsync, getWorkshopLocationAsync, getAllWorkOrderWithoutTechnicianAsync } from './planningThunk';
const smallJobWorkOrderRequest = {
    pageNumber: AppConsts.GRID_DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE,
    workShopLocationId: 1
};
const withoutTechnicianWorkOrderRequest = {
    pageNumber: AppConsts.GRID_DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE,
    workShopLocationId: 1
};
const withTechniciansWorkorderRequest = {
    pageNumber: AppConsts.GRID_DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE,
    workShopLocationId: 1
};
const initialState = {
    status: APIStatus.IDLE,
    smallJobWorkOrderRequest: smallJobWorkOrderRequest,
    withoutTechnicianWorkOrderRequest: withoutTechnicianWorkOrderRequest,
    withTechniciansWorkorderRequest: withTechniciansWorkorderRequest
};
export const planningSlice = createSlice({
    name: 'planning',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllSmallJobWorkOrderAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllSmallJobWorkOrderAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.smallJobWorkOrders = action.payload;
        })
            .addCase(getAllSmallJobWorkOrderAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getWorkshopLocationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getWorkshopLocationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workShopLocation = action.payload;
            state.workShopLocationDropdown = action.payload.map((workshoplocation) => {
                return {
                    label: `${workshoplocation.location}`,
                    value: workshoplocation.id
                };
            });
        })
            .addCase(getWorkshopLocationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllWorkOrderWithoutTechnicianAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllWorkOrderWithoutTechnicianAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.withoutTechnicianWorkOrders = action.payload;
        })
            .addCase(getAllWorkOrderWithoutTechnicianAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllTechniciansWithWorkordersAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllTechniciansWithWorkordersAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.techniciansWithWorkorders = action.payload;
        })
            .addCase(getAllTechniciansWithWorkordersAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default planningSlice.reducer;
